<div *ngIf="evento$ | async as evento">
  <header>
    <div class="view-header">
      <button [routerLink]="['/estudio', 'familia', 'alumno', alumnoId, 'unidad', evento.unidad.id]" mat-icon-button color="primary" class="view-header__back">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h3 class="view-header__cat">{{evento.nombre}}</h3>
    </div>
  </header>
  <div *ngIf="autoevaluacion$ | async as autoevaluacion">
    <div *ngIf="autoevaluacion.eventoMateriaAlumno; else error">
      <div class="featured-content">
        <div class="featured-content__lead">
          {{evento.nombre}}
        </div>
        <div class="featured-content__metadata">
          <mat-chip-set>
            <mat-chip class="glm-chip date-chip">
              <mat-icon cxlass="md-14">calendar_today</mat-icon>
              {{autoevaluacion.unidadEventoMateria.fechaAplicar | date: 'dd LLL yyyy'}}
            </mat-chip>
            <mat-chip *ngFor="let meta of evento.metas" class="glm-chip goal-chip" [matTooltip]="meta.id">
              {{meta.txtIdioma}}</mat-chip>
          </mat-chip-set>
        </div>
        <div *ngIf="autoevaluacion.eventoMateriaAlumnoConfig.mostrarEvidenciaDetalle">
          <div *ngIf="{data: expandido$ | async} as expandido">
            <div class="featured-content__normal" [ngClass]="{'contenidoContraido': expandido.data}"
              [innerHTML]="evento.resumen">
            </div>
            <div class="featured-content__actions">
              <div>
                <button (click)="expandir(!expandido.data)" mat-icon-button color="primary">
                  <mat-icon>{{expandido.data ? 'compress' : 'expand'}}</mat-icon>
                </button>
                <label (click)="expandir(!expandido.data)"
                  role="button">{{expandido.data ? 'Contraer' : 'Expandir'}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div>
        <div class="padding-std">
          <div *ngIf="!autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion" class="message message_warning">
            <div class="message__icon-text">
              <mat-icon class="warning">warning</mat-icon><span>Realice la <strong>autoevaluación</strong> de
                esta
                evidencia para mostrar la evaluación del docente.</span>
            </div>
            <button mat-icon-button color="primary">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div *ngIf="!autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion">
          <div class="padding-std" style="padding-bottom: 0;padding-top: 0;">
            <h4 #anchor class="inner-title">¿Cómo fue mi desempeño
              en esta evidencia? ¿Por
              qué?* <span></span>
            </h4>
            <mat-form-field class="full-width" appearance="outline">
              <textarea matInput [formControl]="textComentarioForm" placeholder="Mi autoevaluación..."></textarea>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion || autoevaluacion.eventoMateriaAlumnoConfig.mostrarComentarioProfesorAntes">
          <div class="padding-std" style="padding-bottom: 0;padding-top: 0;">
            <h4 #anchor class="inner-title">
              Comentarios
            </h4>
            <div *ngIf="comentarioData$ | async as comentarioData; else loading">
              <glm-comentarios [comentarios]="comentarioData.comentarios" [targetID]="autoevaluacion.eventoMateriaAlumnoConfig.eventoMateriaAlumnoId"
                [allowResponse]="comentarioData.editable && autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion" [origen]="'UnidadEventoAlumnoAutoevaluacion'"></glm-comentarios>
            </div>
          </div>
          <ng-template #loading>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-template>
        </div>
        <div *ngIf="autoevaluacion.eventoMateriaAlumnoConfig.mostrarRubrica
        && (autoevaluacion.eventoMateriaAlumnoConfig.requiereAutoevaluacion
        ? autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion
        : true)">
          <div *ngIf="criterios$ | async as criterios">
            <h4 class="inner-title padding-std" style="padding-bottom: 0;">Mis logros en esta evidencia
              <span *ngIf="!autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion">Selecciono el enunciado que mejor describe mi desempeño en esta evidencia</span>
            </h4>
            <div *ngFor="let criterio of criterios; let i = index">
              <div class="padding-std">
                <label class="criteria-numeral">Criterio {{i + 1}}</label>
                <app-autoevaluacion-criterio [criterio]="criterio" [eventoMateriaId]="eventoMateriaId"
                  [autoevaluacion$]="autoevaluacion$" [autoevaluacion]="autoevaluacion">
                </app-autoevaluacion-criterio>
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="!autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion" class="view-footer padding-std">
        <button (click)="submit(autoevaluacion, evento)" mat-raised-button color="primary">Enviar
          autoevaluación</button>
      </div>
    </div>
  </div>
  <ng-template #error>
    <p>Evento no encontrado. Por favor volver a la unidad. Si el error persiste comuniquese con <a
        href="mailto:soporte@glm.edu.co">soporte&#64;glm.edu.co</a>.</p>
  </ng-template>
</div>

<!-- <mat-dialog-actions style="position: absolute; bottom: 24px;">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary">Enviar autoevaluacion</button>
</mat-dialog-actions> -->
